import { performRequest } from 'common/utils/performRequest';

export const GET_GUESTROOM_TYPES_REQUEST = 'GET_GUESTROOM_TYPES_REQUEST';
export const GET_GUESTROOM_TYPES_SUCCESS = 'GET_GUESTROOM_TYPES_SUCCESS';
export const GET_GUESTROOM_TYPES_FAILURE = 'GET_GUESTROOM_TYPES_FAILURE';

export default function getGuestRoomTypes() {
  return async dispatch => {
    dispatch({
      type: GET_GUESTROOM_TYPES_REQUEST,
    });

    try {
      const { data } = await performRequest(
        'get',
        `/api/content/types/rooms`,
        {}
      );

      dispatch({
        type: GET_GUESTROOM_TYPES_SUCCESS,
        payload: data.sort((a, b) => (a.type > b.type ? 1 : -1)),
      });
    } catch (error) {
      dispatch({
        type: GET_GUESTROOM_TYPES_FAILURE,
        payload: error.response.data,
      });
    }
  };
}
